export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    loading: boolean
    content: string
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            loading: true,
            content: ''
        };
    }

    @bind
    start() {
        this.set({
            loading: true,
            content: ''
        });
    }

    @bind
    stop() {
        this.set({
            loading: false,
            content: '正在根据你的需求整理 Bubble 组件方案，并补全 props、slots、样式和 Markdown 渐进渲染表现。',
        });
    }

    @bind
    toggleLoading() {
        if (this.get('loading')) {
            this.stop();
        } else {
            this.start();
        }
    }
}